import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})

export class FeedbackSnackbarService {

  constructor(private snackBar: MatSnackBar) { }

  errorSnackbar(errorMsg: string) {
    this.snackBar.open(errorMsg, 'X', {
      verticalPosition: "top",
      panelClass: ['error-snackbar'],
      "duration": 3000
    });
  }

  successSnackbar(successMsg:string){
    this.snackBar.open(successMsg,'X', {
      verticalPosition: "top",
      panelClass: ['success-snackbar'],
      "duration": 3000
    });
  }
}
